module.exports = __webpack_public_path__ + "media/images/restaurant/areas/central_honshu_m-8f08e92ba0446c380d2814c469beaec6.png";